module.exports = __webpack_public_path__ + "static/hands_bw-b26d75e0d4ce12fdf7cde0fdd09b00da.jpg";